import React, { useState, useMemo, useRef, useEffect } from 'react';
import { CheckCircle, AlertCircle, Plane, Image as ImageIcon, MapPin, ChevronDown, ChevronUp, Calendar, BarChart3, LayoutGrid, Send, Bot, User, ChevronLeft, Menu, Download } from 'lucide-react';
import * as XLSX from 'xlsx';
import ReactMarkdown from 'react-markdown';
import patternLeft from './header/patterns-left.svg';
import patternRight from './header/patterns-right.svg';
import { authFetch } from './auth/authFetch';

// ============ DATA IMPORTS - AUH-LHR Route by Day ============

// SUNDAY - Flight Metadata
import sundayFlight1Metadata from './Data/AUH-LHR/Sunday/flight_1/Flight1_metadata.json';
import sundayFlight2Metadata from './Data/AUH-LHR/Sunday/flight_2/Flight2_metadata.json';
import sundayFlight3Metadata from './Data/AUH-LHR/Sunday/flight_3/Flight3_metadata.json';
import sundayFlight4Metadata from './Data/AUH-LHR/Sunday/flight_4/Flight4_metadata.json';

// SUNDAY - Analysis Results
import sundayFlight1Analysis from './Data/AUH-LHR/Sunday/flight_1/analysis_results.json';
import sundayFlight2Analysis from './Data/AUH-LHR/Sunday/flight_2/analysis_results.json';
import sundayFlight3Analysis from './Data/AUH-LHR/Sunday/flight_3/analysis_results.json';
import sundayFlight4Analysis from './Data/AUH-LHR/Sunday/flight_4/analysis_results.json';

// MONDAY - Flight Metadata
import mondayFlight1Metadata from './Data/AUH-LHR/Monday/flight_1/Flight1_metadata.json';
import mondayFlight2Metadata from './Data/AUH-LHR/Monday/flight_2/Flight2_metadata.json';
import mondayFlight3Metadata from './Data/AUH-LHR/Monday/flight_3/Flight3_metadata.json';
import mondayFlight4Metadata from './Data/AUH-LHR/Monday/flight_4/Flight4_metadata.json';

// MONDAY - Analysis Results
import mondayFlight1Analysis from './Data/AUH-LHR/Monday/flight_1/analysis_results.json';
import mondayFlight2Analysis from './Data/AUH-LHR/Monday/flight_2/analysis_results.json';
import mondayFlight3Analysis from './Data/AUH-LHR/Monday/flight_3/analysis_results.json';
import mondayFlight4Analysis from './Data/AUH-LHR/Monday/flight_4/analysis_results.json';

// TUESDAY - Flight Metadata
import tuesdayFlight1Metadata from './Data/AUH-LHR/Tuesday/flight_1/Flight1_metadata.json';
import tuesdayFlight2Metadata from './Data/AUH-LHR/Tuesday/flight_2/Flight2_metadata.json';
import tuesdayFlight3Metadata from './Data/AUH-LHR/Tuesday/flight_3/Flight3_metadata.json';
import tuesdayFlight4Metadata from './Data/AUH-LHR/Tuesday/flight_4/Flight4_metadata.json';

// TUESDAY - Analysis Results
import tuesdayFlight1Analysis from './Data/AUH-LHR/Tuesday/flight_1/analysis_results.json';
import tuesdayFlight2Analysis from './Data/AUH-LHR/Tuesday/flight_2/analysis_results.json';
import tuesdayFlight3Analysis from './Data/AUH-LHR/Tuesday/flight_3/analysis_results.json';
import tuesdayFlight4Analysis from './Data/AUH-LHR/Tuesday/flight_4/analysis_results.json';

// WEDNESDAY - Flight Metadata
import wednesdayFlight1Metadata from './Data/AUH-LHR/Wednesday/flight_1/Flight1_metadata.json';
import wednesdayFlight2Metadata from './Data/AUH-LHR/Wednesday/flight_2/Flight2_metadata.json';
import wednesdayFlight3Metadata from './Data/AUH-LHR/Wednesday/flight_3/Flight3_metadata.json';
import wednesdayFlight4Metadata from './Data/AUH-LHR/Wednesday/flight_4/Flight4_metadata.json';

// WEDNESDAY - Analysis Results
import wednesdayFlight1Analysis from './Data/AUH-LHR/Wednesday/flight_1/analysis_results.json';
import wednesdayFlight2Analysis from './Data/AUH-LHR/Wednesday/flight_2/analysis_results.json';
import wednesdayFlight3Analysis from './Data/AUH-LHR/Wednesday/flight_3/analysis_results.json';
import wednesdayFlight4Analysis from './Data/AUH-LHR/Wednesday/flight_4/analysis_results.json';

// ============ DATA IMPORTS - AUH-YYZ Route by Day ============

// SUNDAY
import yyzSundayFlight1Metadata from './Data/AUH-YYZ/Sunday/flight_1/Flight1_metadata.json';
import yyzSundayFlight2Metadata from './Data/AUH-YYZ/Sunday/flight_2/Flight2_metadata.json';
import yyzSundayFlight3Metadata from './Data/AUH-YYZ/Sunday/flight_3/Flight3_metadata.json';
import yyzSundayFlight4Metadata from './Data/AUH-YYZ/Sunday/flight_4/Flight4_metadata.json';
import yyzSundayFlight1Analysis from './Data/AUH-YYZ/Sunday/flight_1/analysis_results.json';
import yyzSundayFlight2Analysis from './Data/AUH-YYZ/Sunday/flight_2/analysis_results.json';
import yyzSundayFlight3Analysis from './Data/AUH-YYZ/Sunday/flight_3/analysis_results.json';
import yyzSundayFlight4Analysis from './Data/AUH-YYZ/Sunday/flight_4/analysis_results.json';

// MONDAY
import yyzMondayFlight1Metadata from './Data/AUH-YYZ/Monday/flight_1/Flight1_metadata.json';
import yyzMondayFlight2Metadata from './Data/AUH-YYZ/Monday/flight_2/Flight2_metadata.json';
import yyzMondayFlight3Metadata from './Data/AUH-YYZ/Monday/flight_3/Flight3_metadata.json';
import yyzMondayFlight4Metadata from './Data/AUH-YYZ/Monday/flight_4/Flight4_metadata.json';
import yyzMondayFlight1Analysis from './Data/AUH-YYZ/Monday/flight_1/analysis_results.json';
import yyzMondayFlight2Analysis from './Data/AUH-YYZ/Monday/flight_2/analysis_results.json';
import yyzMondayFlight3Analysis from './Data/AUH-YYZ/Monday/flight_3/analysis_results.json';
import yyzMondayFlight4Analysis from './Data/AUH-YYZ/Monday/flight_4/analysis_results.json';

// TUESDAY
import yyzTuesdayFlight1Metadata from './Data/AUH-YYZ/Tuesday/flight_1/Flight1_metadata.json';
import yyzTuesdayFlight2Metadata from './Data/AUH-YYZ/Tuesday/flight_2/Flight2_metadata.json';
import yyzTuesdayFlight3Metadata from './Data/AUH-YYZ/Tuesday/flight_3/Flight3_metadata.json';
import yyzTuesdayFlight4Metadata from './Data/AUH-YYZ/Tuesday/flight_4/Flight4_metadata.json';
import yyzTuesdayFlight1Analysis from './Data/AUH-YYZ/Tuesday/flight_1/analysis_results.json';
import yyzTuesdayFlight2Analysis from './Data/AUH-YYZ/Tuesday/flight_2/analysis_results.json';
import yyzTuesdayFlight3Analysis from './Data/AUH-YYZ/Tuesday/flight_3/analysis_results.json';
import yyzTuesdayFlight4Analysis from './Data/AUH-YYZ/Tuesday/flight_4/analysis_results.json';

// WEDNESDAY
import yyzWednesdayFlight1Metadata from './Data/AUH-YYZ/Wednesday/flight_1/Flight1_metadata.json';
import yyzWednesdayFlight2Metadata from './Data/AUH-YYZ/Wednesday/flight_2/Flight2_metadata.json';
import yyzWednesdayFlight3Metadata from './Data/AUH-YYZ/Wednesday/flight_3/Flight3_metadata.json';
import yyzWednesdayFlight4Metadata from './Data/AUH-YYZ/Wednesday/flight_4/Flight4_metadata.json';
import yyzWednesdayFlight1Analysis from './Data/AUH-YYZ/Wednesday/flight_1/analysis_results.json';
import yyzWednesdayFlight2Analysis from './Data/AUH-YYZ/Wednesday/flight_2/analysis_results.json';
import yyzWednesdayFlight3Analysis from './Data/AUH-YYZ/Wednesday/flight_3/analysis_results.json';
import yyzWednesdayFlight4Analysis from './Data/AUH-YYZ/Wednesday/flight_4/analysis_results.json';

// Helper function to convert analysis results to image format
const convertAnalysisToImages = (analysisResults, dayId, flightId, dayName, routeFolder) => {
  if (!analysisResults?.images || analysisResults.images.length === 0) return [];

  // Extract flight number from flightId (e.g., 'flight1' -> '1')
  const flightNum = flightId.replace('flight', '');

  return analysisResults.images.map((img, idx) => {
    // Construct the image path for webpack require
    const imagePath = require(`./Data/${routeFolder}/${dayName}/flight_${flightNum}/${img.image_name}`);

    return {
      id: `${dayId}-${flightId}-img${idx}`,
      name: img.image_name,
      preview: imagePath,
      status: img.status === 'success' ? 'complete' : 'error',
      predictions: img.items?.map(item => ({
        name: item.name,
        confidence: item.confidence,
        description: item.description,
        consumptionLevel: item.consumptionLevel
      })) || [],
      error: img.status !== 'success' ? 'Analysis failed' : null
    };
  });
};

// Available routes configuration
const availableRoutes = [
  { id: 'AUH-LHR', origin: 'AUH', destination: 'LHR', label: 'Abu Dhabi → London' },
  { id: 'AUH-YYZ', origin: 'AUH', destination: 'YYZ', label: 'Abu Dhabi → Toronto' },
];

// Organized data by route and day
const allRouteData = {
  'AUH-LHR': {
    Sunday: {
      name: 'Sunday',
      flights: [
        { id: 'lhr-sunday-flight1', metadata: sundayFlight1Metadata.flightMetadata, images: convertAnalysisToImages(sundayFlight1Analysis, 'sunday', 'flight1', 'Sunday', 'AUH-LHR') },
        { id: 'lhr-sunday-flight2', metadata: sundayFlight2Metadata.flightMetadata, images: convertAnalysisToImages(sundayFlight2Analysis, 'sunday', 'flight2', 'Sunday', 'AUH-LHR') },
        { id: 'lhr-sunday-flight3', metadata: sundayFlight3Metadata.flightMetadata, images: convertAnalysisToImages(sundayFlight3Analysis, 'sunday', 'flight3', 'Sunday', 'AUH-LHR') },
        { id: 'lhr-sunday-flight4', metadata: sundayFlight4Metadata.flightMetadata, images: convertAnalysisToImages(sundayFlight4Analysis, 'sunday', 'flight4', 'Sunday', 'AUH-LHR') },
      ]
    },
    Monday: {
      name: 'Monday',
      flights: [
        { id: 'lhr-monday-flight1', metadata: mondayFlight1Metadata.flightMetadata, images: convertAnalysisToImages(mondayFlight1Analysis, 'monday', 'flight1', 'Monday', 'AUH-LHR') },
        { id: 'lhr-monday-flight2', metadata: mondayFlight2Metadata.flightMetadata, images: convertAnalysisToImages(mondayFlight2Analysis, 'monday', 'flight2', 'Monday', 'AUH-LHR') },
        { id: 'lhr-monday-flight3', metadata: mondayFlight3Metadata.flightMetadata, images: convertAnalysisToImages(mondayFlight3Analysis, 'monday', 'flight3', 'Monday', 'AUH-LHR') },
        { id: 'lhr-monday-flight4', metadata: mondayFlight4Metadata.flightMetadata, images: convertAnalysisToImages(mondayFlight4Analysis, 'monday', 'flight4', 'Monday', 'AUH-LHR') },
      ]
    },
    Tuesday: {
      name: 'Tuesday',
      flights: [
        { id: 'lhr-tuesday-flight1', metadata: tuesdayFlight1Metadata.flightMetadata, images: convertAnalysisToImages(tuesdayFlight1Analysis, 'tuesday', 'flight1', 'Tuesday', 'AUH-LHR') },
        { id: 'lhr-tuesday-flight2', metadata: tuesdayFlight2Metadata.flightMetadata, images: convertAnalysisToImages(tuesdayFlight2Analysis, 'tuesday', 'flight2', 'Tuesday', 'AUH-LHR') },
        { id: 'lhr-tuesday-flight3', metadata: tuesdayFlight3Metadata.flightMetadata, images: convertAnalysisToImages(tuesdayFlight3Analysis, 'tuesday', 'flight3', 'Tuesday', 'AUH-LHR') },
        { id: 'lhr-tuesday-flight4', metadata: tuesdayFlight4Metadata.flightMetadata, images: convertAnalysisToImages(tuesdayFlight4Analysis, 'tuesday', 'flight4', 'Tuesday', 'AUH-LHR') },
      ]
    },
    Wednesday: {
      name: 'Wednesday',
      flights: [
        { id: 'lhr-wednesday-flight1', metadata: wednesdayFlight1Metadata.flightMetadata, images: convertAnalysisToImages(wednesdayFlight1Analysis, 'wednesday', 'flight1', 'Wednesday', 'AUH-LHR') },
        { id: 'lhr-wednesday-flight2', metadata: wednesdayFlight2Metadata.flightMetadata, images: convertAnalysisToImages(wednesdayFlight2Analysis, 'wednesday', 'flight2', 'Wednesday', 'AUH-LHR') },
        { id: 'lhr-wednesday-flight3', metadata: wednesdayFlight3Metadata.flightMetadata, images: convertAnalysisToImages(wednesdayFlight3Analysis, 'wednesday', 'flight3', 'Wednesday', 'AUH-LHR') },
        { id: 'lhr-wednesday-flight4', metadata: wednesdayFlight4Metadata.flightMetadata, images: convertAnalysisToImages(wednesdayFlight4Analysis, 'wednesday', 'flight4', 'Wednesday', 'AUH-LHR') },
      ]
    }
  },
  'AUH-YYZ': {
    Sunday: {
      name: 'Sunday',
      flights: [
        { id: 'yyz-sunday-flight1', metadata: yyzSundayFlight1Metadata.flightMetadata, images: convertAnalysisToImages(yyzSundayFlight1Analysis, 'sunday', 'flight1', 'Sunday', 'AUH-YYZ') },
        { id: 'yyz-sunday-flight2', metadata: yyzSundayFlight2Metadata.flightMetadata, images: convertAnalysisToImages(yyzSundayFlight2Analysis, 'sunday', 'flight2', 'Sunday', 'AUH-YYZ') },
        { id: 'yyz-sunday-flight3', metadata: yyzSundayFlight3Metadata.flightMetadata, images: convertAnalysisToImages(yyzSundayFlight3Analysis, 'sunday', 'flight3', 'Sunday', 'AUH-YYZ') },
        { id: 'yyz-sunday-flight4', metadata: yyzSundayFlight4Metadata.flightMetadata, images: convertAnalysisToImages(yyzSundayFlight4Analysis, 'sunday', 'flight4', 'Sunday', 'AUH-YYZ') },
      ]
    },
    Monday: {
      name: 'Monday',
      flights: [
        { id: 'yyz-monday-flight1', metadata: yyzMondayFlight1Metadata.flightMetadata, images: convertAnalysisToImages(yyzMondayFlight1Analysis, 'monday', 'flight1', 'Monday', 'AUH-YYZ') },
        { id: 'yyz-monday-flight2', metadata: yyzMondayFlight2Metadata.flightMetadata, images: convertAnalysisToImages(yyzMondayFlight2Analysis, 'monday', 'flight2', 'Monday', 'AUH-YYZ') },
        { id: 'yyz-monday-flight3', metadata: yyzMondayFlight3Metadata.flightMetadata, images: convertAnalysisToImages(yyzMondayFlight3Analysis, 'monday', 'flight3', 'Monday', 'AUH-YYZ') },
        { id: 'yyz-monday-flight4', metadata: yyzMondayFlight4Metadata.flightMetadata, images: convertAnalysisToImages(yyzMondayFlight4Analysis, 'monday', 'flight4', 'Monday', 'AUH-YYZ') },
      ]
    },
    Tuesday: {
      name: 'Tuesday',
      flights: [
        { id: 'yyz-tuesday-flight1', metadata: yyzTuesdayFlight1Metadata.flightMetadata, images: convertAnalysisToImages(yyzTuesdayFlight1Analysis, 'tuesday', 'flight1', 'Tuesday', 'AUH-YYZ') },
        { id: 'yyz-tuesday-flight2', metadata: yyzTuesdayFlight2Metadata.flightMetadata, images: convertAnalysisToImages(yyzTuesdayFlight2Analysis, 'tuesday', 'flight2', 'Tuesday', 'AUH-YYZ') },
        { id: 'yyz-tuesday-flight3', metadata: yyzTuesdayFlight3Metadata.flightMetadata, images: convertAnalysisToImages(yyzTuesdayFlight3Analysis, 'tuesday', 'flight3', 'Tuesday', 'AUH-YYZ') },
        { id: 'yyz-tuesday-flight4', metadata: yyzTuesdayFlight4Metadata.flightMetadata, images: convertAnalysisToImages(yyzTuesdayFlight4Analysis, 'tuesday', 'flight4', 'Tuesday', 'AUH-YYZ') },
      ]
    },
    Wednesday: {
      name: 'Wednesday',
      flights: [
        { id: 'yyz-wednesday-flight1', metadata: yyzWednesdayFlight1Metadata.flightMetadata, images: convertAnalysisToImages(yyzWednesdayFlight1Analysis, 'wednesday', 'flight1', 'Wednesday', 'AUH-YYZ') },
        { id: 'yyz-wednesday-flight2', metadata: yyzWednesdayFlight2Metadata.flightMetadata, images: convertAnalysisToImages(yyzWednesdayFlight2Analysis, 'wednesday', 'flight2', 'Wednesday', 'AUH-YYZ') },
        { id: 'yyz-wednesday-flight3', metadata: yyzWednesdayFlight3Metadata.flightMetadata, images: convertAnalysisToImages(yyzWednesdayFlight3Analysis, 'wednesday', 'flight3', 'Wednesday', 'AUH-YYZ') },
        { id: 'yyz-wednesday-flight4', metadata: yyzWednesdayFlight4Metadata.flightMetadata, images: convertAnalysisToImages(yyzWednesdayFlight4Analysis, 'wednesday', 'flight4', 'Wednesday', 'AUH-YYZ') },
      ]
    }
  }
};

const availableDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday'];

function App() {
  // Sidebar collapsed state
  const [sidebarOpen, setSidebarOpen] = useState(true);

  // Active tab state - 'agent' or 'route'
  const [activeTab, setActiveTab] = useState('agent');

  // Sub-tab within route: 'details', 'summary', 'trayDetails'
  const [routeSubTab, setRouteSubTab] = useState('details');

  // Selected route
  const [selectedRoute, setSelectedRoute] = useState('AUH-LHR');

  // Selected cabin class
  const [selectedCabin, setSelectedCabin] = useState('Economy');
  const availableCabins = ['Economy', 'Business', 'First', 'Residence'];

  // Selected day for route insights
  const [selectedDay, setSelectedDay] = useState('Sunday');

  // Agent chat state
  const [chatMessages, setChatMessages] = useState([
    { role: 'assistant', content: 'Hello! I\'m your AI catering assistant. I can help you analyze the consumption data from your AUH-LHR flights. Ask me questions like:\n\n• "Which items are consumed the least?"\n• "What\'s the consumption pattern on morning flights?"\n• "Which day had the highest consumption?"\n• "What recommendations do you have to reduce waste?"' }
  ]);
  const [chatInput, setChatInput] = useState('');
  const [isAgentLoading, setIsAgentLoading] = useState(false);
  const chatEndRef = useRef(null);

  // Get current route's data
  const routeDataByDay = allRouteData[selectedRoute];
  const currentRouteConfig = availableRoutes.find(r => r.id === selectedRoute);

  // Route insights state - initialize with pre-loaded data from selected day
  const [routeFlights, setRouteFlights] = useState(() => {
    return routeDataByDay[selectedDay].flights.map(flight => ({
      ...flight,
      isExpanded: false
    }));
  });

  // Update routeFlights when selectedDay or selectedRoute changes
  React.useEffect(() => {
    setRouteFlights(allRouteData[selectedRoute][selectedDay].flights.map(flight => ({
      ...flight,
      isExpanded: false
    })));
  }, [selectedDay, selectedRoute]);

  // Route insights functions
  const toggleFlightExpanded = (flightId) => {
    setRouteFlights(prev => prev.map(flight =>
      flight.id === flightId
        ? { ...flight, isExpanded: !flight.isExpanded }
        : flight
    ));
  };

  // Convert consumption level to numeric percentage (defined early for use in useMemo)
  const consumptionToPercent = (level) => {
    switch (level?.toLowerCase()) {
      case 'untouched': return 0;
      case 'slightly_eaten': return 25;
      case 'half_eaten': return 50;
      case 'mostly_eaten': return 75;
      case 'finished': return 100;
      default: return 0;
    }
  };

  // Calculate route-level consumption summary
  const routeConsumptionSummary = useMemo(() => {
    if (!routeFlights || routeFlights.length === 0) return null;

    const allCompletedImages = routeFlights.flatMap(flight =>
      flight.images?.filter(img => img.status === 'complete') || []
    );

    if (allCompletedImages.length === 0) return null;

    const totalMealsLoaded = routeFlights.reduce((sum, flight) =>
      sum + (flight.metadata?.menuOfTheDay?.[selectedCabin]?.mealsLoaded || 0), 0
    );

    const summary = {};

    // Get all unique menu items across flights
    const allMenuItems = new Set();
    routeFlights.forEach(flight => {
      const menu = flight.metadata?.menuOfTheDay?.[selectedCabin];
      if (!menu) return;
      if (menu.firstService) {
        menu.firstService.mainCourses?.forEach(course => allMenuItems.add(course.name));
        menu.firstService.desserts?.forEach(dessert => allMenuItems.add(dessert));
        menu.firstService.sides?.forEach(side => allMenuItems.add(side));
      }
      if (menu.secondService) {
        menu.secondService.items?.forEach(item => allMenuItems.add(item));
      }
    });

    allMenuItems.forEach(item => {
      summary[item] = {
        name: item,
        totalTrays: 0,
        consumptionLevels: { untouched: 0, slightly_eaten: 0, half_eaten: 0, mostly_eaten: 0, finished: 0 },
        totalConsumedPercent: 0
      };
    });

    allCompletedImages.forEach(image => {
      if (!image.predictions) return;
      image.predictions.forEach(pred => {
        if (summary[pred.name]) {
          summary[pred.name].totalTrays += 1;
          const level = pred.consumptionLevel?.toLowerCase();
          if (summary[pred.name].consumptionLevels[level] !== undefined) {
            summary[pred.name].consumptionLevels[level] += 1;
          }
          summary[pred.name].totalConsumedPercent += consumptionToPercent(pred.consumptionLevel);
        }
      });
    });

    let totalConsumedAcrossAllItems = 0;
    let totalItemsDetected = 0;

    Object.values(summary).forEach(item => {
      if (item.totalTrays > 0) {
        item.averageConsumed = Math.round(item.totalConsumedPercent / item.totalTrays);
        totalConsumedAcrossAllItems += item.averageConsumed;
        totalItemsDetected += 1;
      } else {
        item.averageConsumed = 0;
      }
    });

    const overallConsumption = totalItemsDetected > 0
      ? Math.round(totalConsumedAcrossAllItems / totalItemsDetected)
      : 0;

    // Per-flight summaries
    const flightSummaries = routeFlights.map(flight => {
      const flightImages = flight.images?.filter(img => img.status === 'complete') || [];
      const flightMealsLoaded = flight.metadata?.menuOfTheDay?.[selectedCabin]?.mealsLoaded || 0;

      let flightTotalConsumed = 0;
      let flightItemsCount = 0;

      flightImages.forEach(img => {
        img.predictions?.forEach(pred => {
          flightTotalConsumed += consumptionToPercent(pred.consumptionLevel);
          flightItemsCount += 1;
        });
      });

      return {
        flightId: flight.id,
        flightNumber: flight.metadata?.flightInformation?.flightNumber || 'Unknown',
        departureTime: flight.metadata?.routeDetails?.departureTime || '',
        departureDate: flight.metadata?.routeDetails?.departureDate || '',
        traysAnalyzed: flightImages.length,
        mealsLoaded: flightMealsLoaded,
        overallConsumption: flightItemsCount > 0 ? Math.round(flightTotalConsumed / flightItemsCount) : 0
      };
    });

    return {
      items: summary,
      traysAnalyzed: allCompletedImages.length,
      totalMealsLoaded,
      overallConsumption,
      flightSummaries,
      totalFlights: routeFlights.length
    };
  }, [routeFlights, selectedCabin]);

  // Calculate OVERALL summary across ALL days for the selected route
  const overallSummary = useMemo(() => {
    const currentRouteData = allRouteData[selectedRoute];
    const allFlights = availableDays.flatMap(day => currentRouteData[day].flights);
    const allCompletedImages = allFlights.flatMap(flight =>
      flight.images?.filter(img => img.status === 'complete') || []
    );

    if (allCompletedImages.length === 0) return null;

    const totalMealsLoaded = allFlights.reduce((sum, flight) =>
      sum + (flight.metadata?.menuOfTheDay?.[selectedCabin]?.mealsLoaded || 0), 0
    );

    const summary = {};
    const allMenuItems = new Set();

    allFlights.forEach(flight => {
      const menu = flight.metadata?.menuOfTheDay?.[selectedCabin];
      if (!menu) return;
      if (menu.firstService) {
        menu.firstService.mainCourses?.forEach(course => allMenuItems.add(course.name));
        menu.firstService.desserts?.forEach(dessert => allMenuItems.add(dessert));
        menu.firstService.sides?.forEach(side => allMenuItems.add(side));
      }
      if (menu.secondService) {
        menu.secondService.items?.forEach(item => allMenuItems.add(item));
      }
    });

    allMenuItems.forEach(item => {
      summary[item] = {
        name: item,
        totalTrays: 0,
        consumptionLevels: { untouched: 0, slightly_eaten: 0, half_eaten: 0, mostly_eaten: 0, finished: 0 },
        totalConsumedPercent: 0
      };
    });

    allCompletedImages.forEach(image => {
      if (!image.predictions) return;
      image.predictions.forEach(pred => {
        if (summary[pred.name]) {
          summary[pred.name].totalTrays += 1;
          const level = pred.consumptionLevel?.toLowerCase();
          if (summary[pred.name].consumptionLevels[level] !== undefined) {
            summary[pred.name].consumptionLevels[level] += 1;
          }
          summary[pred.name].totalConsumedPercent += consumptionToPercent(pred.consumptionLevel);
        }
      });
    });

    let totalConsumedAcrossAllItems = 0;
    let totalItemsDetected = 0;

    Object.values(summary).forEach(item => {
      if (item.totalTrays > 0) {
        item.averageConsumed = Math.round(item.totalConsumedPercent / item.totalTrays);
        totalConsumedAcrossAllItems += item.averageConsumed;
        totalItemsDetected += 1;
      } else {
        item.averageConsumed = 0;
      }
    });

    const overallConsumption = totalItemsDetected > 0
      ? Math.round(totalConsumedAcrossAllItems / totalItemsDetected)
      : 0;

    // Per-day summaries
    const daySummaries = availableDays.map(day => {
      const dayFlights = currentRouteData[day].flights;
      const dayImages = dayFlights.flatMap(f => f.images?.filter(img => img.status === 'complete') || []);
      const dayMealsLoaded = dayFlights.reduce((sum, f) => sum + (f.metadata?.menuOfTheDay?.[selectedCabin]?.mealsLoaded || 0), 0);
      // Get the date from the first flight of the day
      const dayDate = dayFlights[0]?.metadata?.routeDetails?.departureDate || '';

      let dayTotalConsumed = 0;
      let dayItemsCount = 0;

      dayImages.forEach(img => {
        img.predictions?.forEach(pred => {
          dayTotalConsumed += consumptionToPercent(pred.consumptionLevel);
          dayItemsCount += 1;
        });
      });

      return {
        day,
        date: dayDate,
        totalFlights: dayFlights.length,
        traysAnalyzed: dayImages.length,
        mealsLoaded: dayMealsLoaded,
        overallConsumption: dayItemsCount > 0 ? Math.round(dayTotalConsumed / dayItemsCount) : 0
      };
    });

    return {
      items: summary,
      traysAnalyzed: allCompletedImages.length,
      totalMealsLoaded,
      overallConsumption,
      totalFlights: allFlights.length,
      totalDays: availableDays.length,
      daySummaries
    };
  }, [selectedRoute, selectedCabin]);

  // Get ALL tray images across all days and flights for the Tray Details tab
  const allTrayImages = useMemo(() => {
    const currentRouteData = allRouteData[selectedRoute];
    const trays = [];
    availableDays.forEach(day => {
      currentRouteData[day].flights.forEach(flight => {
        flight.images?.forEach(image => {
          if (image.status === 'complete') {
            trays.push({
              ...image,
              day,
              flightNumber: flight.metadata?.flightInformation?.flightNumber || 'Unknown',
              flightId: flight.id,
              departureDate: flight.metadata?.routeDetails?.departureDate || '',
              departureTime: flight.metadata?.routeDetails?.departureTime || ''
            });
          }
        });
      });
    });
    return trays;
  }, [selectedRoute, selectedCabin]);

  // Scroll to bottom of chat when new messages arrive
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chatMessages]);

  // Prepare data summary for the agent
  const agentDataSummary = useMemo(() => {
    if (!overallSummary) return null;

    // Build a comprehensive data summary for the agent
    const currentRouteData = allRouteData[selectedRoute];
    const flightDetails = [];
    availableDays.forEach(day => {
      currentRouteData[day].flights.forEach(flight => {
        const completedImages = flight.images?.filter(img => img.status === 'complete') || [];
        const flightConsumption = {};

        completedImages.forEach(img => {
          img.predictions?.forEach(pred => {
            if (!flightConsumption[pred.name]) {
              flightConsumption[pred.name] = { total: 0, count: 0 };
            }
            flightConsumption[pred.name].total += consumptionToPercent(pred.consumptionLevel);
            flightConsumption[pred.name].count += 1;
          });
        });

        const itemAverages = {};
        Object.entries(flightConsumption).forEach(([name, data]) => {
          itemAverages[name] = Math.round(data.total / data.count);
        });

        flightDetails.push({
          day,
          date: flight.metadata?.routeDetails?.departureDate,
          flightNumber: flight.metadata?.flightInformation?.flightNumber,
          departureTime: flight.metadata?.routeDetails?.departureTime,
          traysAnalyzed: completedImages.length,
          itemConsumption: itemAverages
        });
      });
    });

    return {
      overview: {
        totalDays: overallSummary.totalDays,
        totalFlights: overallSummary.totalFlights,
        totalTraysAnalyzed: overallSummary.traysAnalyzed,
        overallConsumption: overallSummary.overallConsumption
      },
      byDay: overallSummary.daySummaries,
      byItem: Object.values(overallSummary.items).map(item => ({
        name: item.name,
        averageConsumption: item.averageConsumed,
        timesDetected: item.totalTrays,
        consumptionBreakdown: item.consumptionLevels
      })),
      flightDetails
    };
  }, [overallSummary, selectedRoute, selectedCabin]);

  // Send message to agent
  const sendMessageToAgent = async () => {
    if (!chatInput.trim() || isAgentLoading) return;

    const userMessage = chatInput.trim();
    setChatInput('');
    setChatMessages(prev => [...prev, { role: 'user', content: userMessage }]);
    setIsAgentLoading(true);

    try {
      const response = await authFetch('/api/agent/chat', {
        method: 'POST',
        body: JSON.stringify({
          message: userMessage,
          cateringData: agentDataSummary
        })
      });

      if (response.status === 401) {
        setChatMessages(prev => [...prev, { role: 'assistant', content: 'Your session has expired or you are not authorized. Please refresh the page and sign in again.' }]);
        return;
      }

      const data = await response.json();

      if (response.ok) {
        setChatMessages(prev => [...prev, { role: 'assistant', content: data.response }]);
      } else {
        setChatMessages(prev => [...prev, { role: 'assistant', content: 'Sorry, I encountered an error. Please make sure the server is running on port 3001.' }]);
      }
    } catch (error) {
      setChatMessages(prev => [...prev, { role: 'assistant', content: 'Unable to connect to the server. Please ensure the backend server is running with `node server.js`.' }]);
    } finally {
      setIsAgentLoading(false);
    }
  };

  // Export route data to Excel
  const exportToExcel = () => {
    const wb = XLSX.utils.book_new();
    const routeLabel = `${currentRouteConfig.origin}-${currentRouteConfig.destination}`;

    // Sheet 1: Flight Details
    const flightRows = [];
    availableDays.forEach(day => {
      const dayFlights = allRouteData[selectedRoute][day].flights;
      dayFlights.forEach(flight => {
        const meta = flight.metadata;
        const completedImages = flight.images?.filter(img => img.status === 'complete') || [];
        let totalConsumed = 0;
        let itemCount = 0;
        completedImages.forEach(img => {
          img.predictions?.forEach(pred => {
            totalConsumed += consumptionToPercent(pred.consumptionLevel);
            itemCount += 1;
          });
        });
        flightRows.push({
          'Day': day,
          'Date': meta?.routeDetails?.departureDate || '',
          'Flight Number': meta?.flightInformation?.flightNumber || '',
          'Aircraft': meta?.flightInformation?.aircraftType || '',
          'Departure': meta?.routeDetails?.departureTime || '',
          'Arrival': meta?.routeDetails?.arrivalTime || '',
          'Cabin': selectedCabin,
          'Meals Loaded': meta?.menuOfTheDay?.[selectedCabin]?.mealsLoaded || 0,
          'Trays Analyzed': completedImages.length,
          'Avg Consumption %': itemCount > 0 ? Math.round(totalConsumed / itemCount) : 0,
          'Booked Passengers': meta?.passengerInfo?.bookedPassengers || 0,
        });
      });
    });
    const ws1 = XLSX.utils.json_to_sheet(flightRows);
    ws1['!cols'] = flightRows.length > 0 ? Object.keys(flightRows[0]).map(() => ({ wch: 18 })) : [];
    XLSX.utils.book_append_sheet(wb, ws1, 'Flight Details');

    // Sheet 2: Consumption by Menu Item
    if (overallSummary?.items) {
      const itemRows = Object.values(overallSummary.items).map(item => ({
        'Menu Item': item.name,
        'Avg Consumption %': item.averageConsumed || 0,
        'Times Detected': item.totalTrays,
        'Untouched': item.consumptionLevels.untouched,
        'Slightly Eaten': item.consumptionLevels.slightly_eaten,
        'Half Eaten': item.consumptionLevels.half_eaten,
        'Mostly Eaten': item.consumptionLevels.mostly_eaten,
        'Finished': item.consumptionLevels.finished,
      }));
      const ws2 = XLSX.utils.json_to_sheet(itemRows);
      ws2['!cols'] = itemRows.length > 0 ? Object.keys(itemRows[0]).map(k => ({ wch: k === 'Menu Item' ? 50 : 18 })) : [];
      XLSX.utils.book_append_sheet(wb, ws2, 'Consumption by Item');
    }

    // Sheet 3: Daily Summary
    if (overallSummary?.daySummaries) {
      const dayRows = overallSummary.daySummaries.map(ds => ({
        'Day': ds.day,
        'Date': ds.date,
        'Total Flights': ds.totalFlights,
        'Meals Loaded': ds.mealsLoaded,
        'Trays Analyzed': ds.traysAnalyzed,
        'Avg Consumption %': ds.overallConsumption,
      }));
      const ws3 = XLSX.utils.json_to_sheet(dayRows);
      ws3['!cols'] = dayRows.length > 0 ? Object.keys(dayRows[0]).map(() => ({ wch: 18 })) : [];
      XLSX.utils.book_append_sheet(wb, ws3, 'Daily Summary');
    }

    // Download
    XLSX.writeFile(wb, `${routeLabel}_${selectedCabin}_Report.xlsx`);
  };

  const getConsumptionLevelStyle = (level) => {
    switch (level?.toLowerCase()) {
      case 'untouched':
        return { color: 'bg-emerald-100 text-emerald-800 border-emerald-300', label: 'Untouched', percent: '0%' };
      case 'slightly_eaten':
        return { color: 'bg-lime-100 text-lime-800 border-lime-300', label: 'Slightly Eaten', percent: '~25%' };
      case 'half_eaten':
        return { color: 'bg-amber-100 text-amber-800 border-amber-300', label: 'Half Eaten', percent: '~50%' };
      case 'mostly_eaten':
        return { color: 'bg-orange-100 text-orange-800 border-orange-300', label: 'Mostly Eaten', percent: '~75%' };
      case 'finished':
        return { color: 'bg-red-100 text-red-800 border-red-300', label: 'Finished', percent: '100%' };
      default:
        return { color: 'bg-gray-100 text-gray-800 border-gray-300', label: 'Unknown', percent: '?' };
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'complete':
        return <CheckCircle className="w-5 h-5 text-green-600" />;
      case 'error':
        return <AlertCircle className="w-5 h-5 text-red-600" />;
      default:
        return <ImageIcon className="w-5 h-5 text-gray-400" />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-white">
      {/* Header - Full Width */}
      <div className="relative w-full py-4 px-8 border-b-2 overflow-hidden" style={{ borderColor: '#263a46', backgroundColor: '#263a46' }}>
        {/* Left Pattern */}
        <img
          src={patternLeft}
          alt=""
          className="absolute left-0 top-0 h-full w-auto opacity-60"
          style={{ maxWidth: '250px' }}
        />
        {/* Right Pattern */}
        <img
          src={patternRight}
          alt=""
          className="absolute right-0 top-0 h-full w-auto opacity-60"
          style={{ maxWidth: '250px' }}
        />
        {/* Header Content */}
        <div className="text-center relative z-10">
          <h1 className="text-3xl font-bold text-white mb-1">Etihad Catering Platform</h1>
          <p className="text-gray-600 text-sm">Powered by AI</p>
        </div>
      </div>

      {/* Main Content with padding */}
      <div className="p-4">

      <div className="flex gap-4 max-w-[1800px] mx-auto">
        {/* Left Sidebar - Navigation (Collapsible) */}
        <div className={`flex-shrink-0 transition-all duration-300 ${sidebarOpen ? 'w-64' : 'w-16'}`}>
          <div className="bg-white rounded-xl shadow-lg sticky top-4 overflow-hidden">
            {/* Logo Section */}
            <div className={`flex items-center justify-center border-b border-gray-100 ${sidebarOpen ? 'p-4' : 'p-3'}`}>
              {sidebarOpen ? (
                <img src="/BeyondBorder_Gold.webp" alt="Logo" className="h-14 w-auto" />
              ) : (
                <img src="/image.png" alt="Logo" className="h-8 w-8 object-contain" />
              )}
            </div>

            {/* Toggle Button */}
            <div className={`flex items-center ${sidebarOpen ? 'justify-between p-4' : 'justify-center p-3'}`}>
              {sidebarOpen && (
                <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider">Navigation</h3>
              )}
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="p-2 rounded-lg hover:bg-gray-100 transition-colors text-gray-500"
              >
                {sidebarOpen ? <ChevronLeft className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
              </button>
            </div>

            <nav className={`space-y-2 ${sidebarOpen ? 'px-4 pb-4' : 'px-2 pb-3'}`}>
              <button
                onClick={() => setActiveTab('agent')}
                className={`w-full flex items-center gap-3 ${sidebarOpen ? 'px-4 py-3' : 'px-3 py-3 justify-center'} rounded-lg font-medium transition-all ${
                  activeTab === 'agent'
                    ? 'bg-amber-100 text-amber-800 shadow-sm'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
                title="AI Assistant"
              >
                <Bot className="w-5 h-5" />
                {sidebarOpen && 'AI Assistant'}
              </button>
              <button
                onClick={() => setActiveTab('route')}
                className={`w-full flex items-center gap-3 ${sidebarOpen ? 'px-4 py-3' : 'px-3 py-3 justify-center'} rounded-lg font-medium transition-all ${
                  activeTab === 'route'
                    ? 'bg-purple-100 text-purple-800 shadow-sm'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
                title="Route"
              >
                <Plane className="w-5 h-5" />
                {sidebarOpen && 'Route'}
              </button>
            </nav>

            {/* Route info in sidebar - Only show when sidebar is open and route tab is active */}
            {sidebarOpen && activeTab === 'route' && (
              <div className="mx-4 mb-4 pt-4 border-t border-gray-200">
                <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">Quick Stats</h3>
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-lg font-bold text-purple-700">{currentRouteConfig.origin}</span>
                  <span className="text-gray-400">→</span>
                  <span className="text-lg font-bold text-purple-700">{currentRouteConfig.destination}</span>
                </div>
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Total Trays</span>
                    <span className="font-bold text-gray-800">{overallSummary?.traysAnalyzed || 0}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Total Flights</span>
                    <span className="font-bold text-gray-800">{overallSummary?.totalFlights || 0}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Consumption</span>
                    <span className={`font-bold ${
                      (overallSummary?.overallConsumption || 0) >= 75 ? 'text-green-600' :
                      (overallSummary?.overallConsumption || 0) >= 50 ? 'text-lime-600' :
                      'text-orange-500'
                    }`}>{overallSummary?.overallConsumption || 0}%</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Main Content Area */}
        <div className="flex-1 min-w-0">
          {/* Agent View - Shows in center when agent tab is active */}
          {activeTab === 'agent' && (
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="p-6" style={{ backgroundColor: '#b08747' }}>
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 rounded-full bg-white/20 flex items-center justify-center">
                    <Bot className="w-8 h-8 text-white" />
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-white">AI Catering Assistant</h2>
                    <p className="text-amber-100">Ask questions about your catering consumption data</p>
                  </div>
                </div>
              </div>

              {/* Chat Messages - Larger area when in center */}
              <div className="h-[500px] overflow-y-auto p-6 space-y-4 bg-gray-50">
                {chatMessages.map((msg, idx) => (
                  <div
                    key={idx}
                    className={`flex gap-3 ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}
                  >
                    {msg.role === 'assistant' && (
                      <div className="flex-shrink-0 w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
                        <Bot className="w-6 h-6 text-amber-700" />
                      </div>
                    )}
                    <div
                      className={`max-w-[70%] rounded-2xl px-5 py-3 ${
                        msg.role === 'user'
                          ? 'text-gray-800 border'
                          : 'bg-white text-gray-800 shadow-md border border-gray-100'
                      }`}
                      style={msg.role === 'user' ? { backgroundColor: '#fdf9ef', borderColor: '#fdf9ef' } : {}}
                    >
                      {msg.role === 'assistant' ? (
                        <div className="prose prose-sm max-w-none prose-headings:text-gray-800 prose-headings:font-bold prose-headings:mt-2 prose-headings:mb-1 prose-p:my-1 prose-ul:my-1 prose-li:my-0 prose-strong:text-gray-900">
                          <ReactMarkdown>{msg.content}</ReactMarkdown>
                        </div>
                      ) : (
                        <p>{msg.content}</p>
                      )}
                    </div>
                    {msg.role === 'user' && (
                      <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: '#fdf9ef' }}>
                        <User className="w-6 h-6 text-gray-700" />
                      </div>
                    )}
                  </div>
                ))}
                {isAgentLoading && (
                  <div className="flex gap-3 justify-start">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
                      <Bot className="w-6 h-6 text-amber-700" />
                    </div>
                    <div className="bg-white rounded-2xl px-5 py-3 shadow-md border border-gray-100">
                      <div className="flex gap-1">
                        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
                      </div>
                    </div>
                  </div>
                )}
                <div ref={chatEndRef} />
              </div>

              {/* Quick Questions */}
              <div className="p-4 border-t border-gray-200 bg-white">
                <div className="flex flex-wrap gap-2 mb-4">
                  {[
                    "Which items are consumed the least?",
                    "What's the best consumption day?",
                    "Morning vs evening flight patterns?",
                    "How can we reduce waste?"
                  ].map((question, idx) => (
                    <button
                      key={idx}
                      onClick={() => setChatInput(question)}
                      className="px-3 py-1.5 bg-gray-100 text-gray-600 rounded-full text-sm hover:bg-amber-50 hover:text-amber-700 transition-colors"
                    >
                      {question}
                    </button>
                  ))}
                </div>

                {/* Chat Input */}
                <div className="flex gap-3">
                  <input
                    type="text"
                    value={chatInput}
                    onChange={(e) => setChatInput(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && sendMessageToAgent()}
                    placeholder="Ask a question about your catering data..."
                    className="flex-1 px-4 py-3 border border-gray-300 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                    disabled={isAgentLoading}
                  />
                  <button
                    onClick={sendMessageToAgent}
                    disabled={isAgentLoading || !chatInput.trim()}
                    className={`px-6 py-3 rounded-xl transition-colors flex items-center gap-2 ${
                      isAgentLoading || !chatInput.trim()
                        ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                        : 'text-white hover:opacity-90'
                    }`}
                    style={!isAgentLoading && chatInput.trim() ? { backgroundColor: '#b08747' } : {}}
                  >
                    <Send className="w-5 h-5" />
                    <span>Send</span>
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Route Tab - contains route selector, sub-tabs, and all route content */}
          {activeTab === 'route' && (
          <div className="space-y-4">
            {/* Route Selector + Sub-tabs Header */}
            <div className="bg-white rounded-xl shadow-lg p-5">
              {/* Route Selector */}
              <div className="flex items-center gap-4 mb-4">
                <div className="flex items-center gap-2">
                  <Plane className="w-6 h-6 text-purple-600" />
                  <h3 className="text-lg font-bold text-gray-800">Route</h3>
                </div>
                <div className="flex gap-2">
                  {availableRoutes.map((route) => (
                    <button
                      key={route.id}
                      onClick={() => setSelectedRoute(route.id)}
                      className={`px-4 py-2 rounded-lg font-semibold transition-all flex items-center gap-2 text-sm ${
                        selectedRoute === route.id
                          ? 'bg-purple-600 text-white shadow-md'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      <span>{route.origin}</span>
                      <span className="text-xs">→</span>
                      <span>{route.destination}</span>
                    </button>
                  ))}
                </div>
              </div>

              {/* Cabin Class Selector */}
              <div className="flex items-center gap-4 mt-4">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-gray-500">Cabin</h3>
                </div>
                <div className="flex gap-2">
                  {availableCabins.map((cabin) => (
                    <button
                      key={cabin}
                      onClick={() => setSelectedCabin(cabin)}
                      className={`px-3 py-1.5 rounded-lg font-medium transition-all text-sm ${
                        selectedCabin === cabin
                          ? 'bg-purple-100 text-purple-800 border border-purple-300 shadow-sm'
                          : 'bg-gray-50 text-gray-600 border border-gray-200 hover:bg-gray-100'
                      }`}
                    >
                      {cabin}
                    </button>
                  ))}
                </div>
              </div>

              {/* Sub-tabs */}
              <div className="flex gap-1 bg-gray-100 rounded-lg p-1 mt-4">
                <button
                  onClick={() => setRouteSubTab('details')}
                  className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-md font-medium text-sm transition-all ${
                    routeSubTab === 'details'
                      ? 'bg-white text-purple-700 shadow-sm'
                      : 'text-gray-600 hover:text-gray-800'
                  }`}
                >
                  <MapPin className="w-4 h-4" />
                  Details
                </button>
                <button
                  onClick={() => setRouteSubTab('summary')}
                  className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-md font-medium text-sm transition-all ${
                    routeSubTab === 'summary'
                      ? 'bg-white text-blue-700 shadow-sm'
                      : 'text-gray-600 hover:text-gray-800'
                  }`}
                >
                  <BarChart3 className="w-4 h-4" />
                  Summary
                </button>
                <button
                  onClick={() => setRouteSubTab('trayDetails')}
                  className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-md font-medium text-sm transition-all ${
                    routeSubTab === 'trayDetails'
                      ? 'bg-white text-green-700 shadow-sm'
                      : 'text-gray-600 hover:text-gray-800'
                  }`}
                >
                  <LayoutGrid className="w-4 h-4" />
                  Tray Details
                </button>
              </div>
            </div>

          {/* Sub-tab Content */}
          <div className="bg-white rounded-xl shadow-lg p-6">

          {/* Summary Sub-tab */}
          {routeSubTab === 'summary' && overallSummary && (
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6 border-2 border-blue-200">
              <div className="flex items-center gap-3 mb-6">
                <BarChart3 className="w-8 h-8 text-blue-600" />
                <div>
                  <h2 className="text-2xl font-bold text-gray-800">Overall Consumption Summary</h2>
                  <p className="text-gray-500">Aggregated data across all days and flights</p>
                </div>
              </div>

              {/* Overall Stats Cards */}
              <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6">
                <div className="bg-white rounded-xl p-4 text-center shadow-md border border-blue-200">
                  <p className="text-3xl font-bold text-blue-600">{overallSummary.totalDays}</p>
                  <p className="text-sm text-gray-600">Total Days</p>
                </div>
                <div className="bg-white rounded-xl p-4 text-center shadow-md border border-purple-200">
                  <p className="text-3xl font-bold text-purple-600">{overallSummary.totalFlights}</p>
                  <p className="text-sm text-gray-600">Total Flights</p>
                </div>
                <div className="bg-white rounded-xl p-4 text-center shadow-md border border-indigo-200">
                  <p className="text-3xl font-bold text-indigo-600">{overallSummary.totalMealsLoaded}</p>
                  <p className="text-sm text-gray-600">Total Meals Loaded</p>
                </div>
                <div className="bg-white rounded-xl p-4 text-center shadow-md border border-green-200">
                  <p className="text-3xl font-bold text-green-600">{overallSummary.traysAnalyzed}</p>
                  <p className="text-sm text-gray-600">Trays Analyzed</p>
                </div>
                <div className="bg-white rounded-xl p-4 text-center shadow-md border border-amber-200">
                  <p className={`text-3xl font-bold ${
                    overallSummary.overallConsumption >= 75 ? 'text-green-600' :
                    overallSummary.overallConsumption >= 50 ? 'text-lime-600' :
                    overallSummary.overallConsumption >= 25 ? 'text-orange-500' :
                    'text-red-600'
                  }`}>{overallSummary.overallConsumption}%</p>
                  <p className="text-sm text-gray-600">Overall Consumption</p>
                </div>
              </div>

              {/* Overall Progress Bar */}
              <div className="bg-white rounded-xl p-4 mb-6 shadow-md">
                <div className="flex justify-between text-sm text-gray-600 mb-2">
                  <span>Overall Consumption Score (All Days)</span>
                  <span className="font-semibold">{overallSummary.overallConsumption}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-5">
                  <div
                    className={`h-5 rounded-full transition-all duration-500 ${
                      overallSummary.overallConsumption >= 75 ? 'bg-green-500' :
                      overallSummary.overallConsumption >= 50 ? 'bg-lime-500' :
                      overallSummary.overallConsumption >= 25 ? 'bg-orange-500' :
                      'bg-red-500'
                    }`}
                    style={{ width: `${overallSummary.overallConsumption}%` }}
                  />
                </div>
                <p className="text-xs text-gray-500 mt-2">
                  Based on {overallSummary.traysAnalyzed} analyzed trays across {overallSummary.totalFlights} flights over {overallSummary.totalDays} days
                </p>
              </div>

              {/* Per-Day Comparison */}
              <div className="bg-white rounded-xl p-4 mb-6 shadow-md">
                <h3 className="text-lg font-bold text-gray-800 mb-4">Consumption by Day</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  {overallSummary.daySummaries.map((daySum, idx) => (
                    <div key={idx} className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-4 border border-gray-200">
                      <div className="flex items-center gap-2 mb-1">
                        <Calendar className="w-5 h-5 text-purple-600" />
                        <span className="font-bold text-gray-800">{daySum.day}</span>
                      </div>
                      <p className="text-xs text-gray-500 mb-2 ml-7">{daySum.date}</p>
                      <div className="space-y-2">
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-500">Flights</span>
                          <span className="font-semibold">{daySum.totalFlights}</span>
                        </div>
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-500">Trays Analyzed</span>
                          <span className="font-semibold">{daySum.traysAnalyzed}/{daySum.mealsLoaded}</span>
                        </div>
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-500">Consumption</span>
                          <span className={`font-bold ${
                            daySum.overallConsumption >= 75 ? 'text-green-600' :
                            daySum.overallConsumption >= 50 ? 'text-lime-600' :
                            daySum.overallConsumption >= 25 ? 'text-orange-500' :
                            'text-red-500'
                          }`}>{daySum.overallConsumption}%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
                          <div
                            className={`h-2 rounded-full ${
                              daySum.overallConsumption >= 75 ? 'bg-green-500' :
                              daySum.overallConsumption >= 50 ? 'bg-lime-500' :
                              daySum.overallConsumption >= 25 ? 'bg-orange-500' :
                              'bg-red-500'
                            }`}
                            style={{ width: `${daySum.overallConsumption}%` }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Per-Item Consumption Summary */}
              <div className="bg-white rounded-xl p-4 shadow-md">
                <h3 className="text-lg font-bold text-gray-800 mb-4">Consumption by Menu Item (All Days)</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {Object.values(overallSummary.items).map((item, idx) => (
                    <div key={idx} className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                      <h5 className="font-bold text-gray-800 mb-3">{item.name}</h5>
                      {item.totalTrays > 0 ? (
                        <>
                          <div className="mb-2">
                            <div className="flex justify-between text-sm text-gray-600 mb-1">
                              <span>Average Consumed</span>
                              <span className={`font-semibold ${
                                item.averageConsumed >= 75 ? 'text-green-600' :
                                item.averageConsumed >= 50 ? 'text-lime-600' :
                                item.averageConsumed >= 25 ? 'text-orange-500' :
                                'text-red-500'
                              }`}>{item.averageConsumed}%</span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-3">
                              <div
                                className={`h-3 rounded-full transition-all duration-500 ${
                                  item.averageConsumed >= 75 ? 'bg-green-500' :
                                  item.averageConsumed >= 50 ? 'bg-lime-500' :
                                  item.averageConsumed >= 25 ? 'bg-orange-500' :
                                  item.averageConsumed > 0 ? 'bg-red-400' : 'bg-gray-300'
                                }`}
                                style={{ width: `${item.averageConsumed}%` }}
                              />
                            </div>
                          </div>
                          <p className="text-xs text-gray-500 mb-2">
                            Detected in {item.totalTrays} trays
                          </p>
                          <div className="flex flex-wrap gap-1">
                            {item.consumptionLevels.untouched > 0 && (
                              <span className="px-2 py-1 bg-emerald-100 text-emerald-800 rounded text-xs">
                                Untouched: {item.consumptionLevels.untouched}
                              </span>
                            )}
                            {item.consumptionLevels.slightly_eaten > 0 && (
                              <span className="px-2 py-1 bg-lime-100 text-lime-800 rounded text-xs">
                                Slightly: {item.consumptionLevels.slightly_eaten}
                              </span>
                            )}
                            {item.consumptionLevels.half_eaten > 0 && (
                              <span className="px-2 py-1 bg-amber-100 text-amber-800 rounded text-xs">
                                Half: {item.consumptionLevels.half_eaten}
                              </span>
                            )}
                            {item.consumptionLevels.mostly_eaten > 0 && (
                              <span className="px-2 py-1 bg-orange-100 text-orange-800 rounded text-xs">
                                Mostly: {item.consumptionLevels.mostly_eaten}
                              </span>
                            )}
                            {item.consumptionLevels.finished > 0 && (
                              <span className="px-2 py-1 bg-red-100 text-red-800 rounded text-xs">
                                Finished: {item.consumptionLevels.finished}
                              </span>
                            )}
                          </div>
                        </>
                      ) : (
                        <p className="text-sm text-gray-400 italic">Not detected in any tray</p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Details Sub-tab */}
          {routeSubTab === 'details' && (
            <div className="bg-gradient-to-r from-purple-50 to-indigo-50 rounded-2xl p-6 border-2 border-purple-200">
              {/* Day Selector */}
              <div className="bg-white rounded-xl p-4 mb-6 shadow-md">
                <div className="flex items-center gap-3 mb-3">
                  <Calendar className="w-6 h-6 text-purple-600" />
                  <h3 className="text-lg font-bold text-gray-800">Select Day</h3>
                </div>
                <div className="flex flex-wrap gap-2">
                  {availableDays.map((day) => (
                    <button
                      key={day}
                      onClick={() => setSelectedDay(day)}
                      className={`px-4 py-2 rounded-lg font-semibold transition-colors ${
                        selectedDay === day
                          ? 'bg-purple-600 text-white'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      {day}
                    </button>
                  ))}
                </div>
              </div>

              {/* Route Header */}
              <div className="bg-white rounded-xl p-4 mb-6 shadow-md">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <MapPin className="w-8 h-8 text-purple-600" />
                    <div>
                      <h2 className="text-2xl font-bold text-gray-800">Route: {currentRouteConfig.origin} → {currentRouteConfig.destination} ({selectedDay})</h2>
                      <p className="text-gray-500">Consumption analysis across all flights on this route for {selectedDay}</p>
                    </div>
                  </div>
                  <button
                    onClick={exportToExcel}
                    className="flex items-center gap-2 px-4 py-2.5 bg-purple-600 text-white rounded-lg font-medium text-sm hover:bg-purple-700 transition-colors shadow-sm"
                  >
                    <Download className="w-4 h-4" />
                    Export Excel
                  </button>
                </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
                      <div className="text-center p-3 bg-purple-50 rounded-lg">
                        <p className="text-2xl font-bold text-purple-700">{routeFlights.length}</p>
                        <p className="text-sm text-gray-500">Total Flights</p>
                      </div>
                      <div className="text-center p-3 bg-blue-50 rounded-lg">
                        <p className="text-2xl font-bold text-blue-700">
                          {routeFlights.reduce((sum, f) => sum + (f.metadata.menuOfTheDay[selectedCabin]?.mealsLoaded || 0), 0)}
                        </p>
                        <p className="text-sm text-gray-500">Total Meals Loaded</p>
                      </div>
                      <div className="text-center p-3 bg-green-50 rounded-lg">
                        <p className="text-2xl font-bold text-green-700">
                          {routeFlights.reduce((sum, f) => sum + f.images.filter(img => img.status === 'complete').length, 0)}
                        </p>
                        <p className="text-sm text-gray-500">Trays Analyzed</p>
                      </div>
                      <div className="text-center p-3 bg-amber-50 rounded-lg">
                        <p className={`text-2xl font-bold ${
                          routeConsumptionSummary?.overallConsumption >= 75 ? 'text-green-600' :
                          routeConsumptionSummary?.overallConsumption >= 50 ? 'text-lime-600' :
                          routeConsumptionSummary?.overallConsumption >= 25 ? 'text-orange-500' :
                          'text-red-600'
                        }`}>
                          {routeConsumptionSummary?.overallConsumption || 0}%
                        </p>
                        <p className="text-sm text-gray-500">Route Consumption</p>
                      </div>
                    </div>
                  </div>

                  {/* Overall Consumption Summary */}
                  {routeConsumptionSummary && (
                    <div className="bg-white rounded-xl p-6 mb-6 shadow-md">
                      <h3 className="text-xl font-bold text-gray-800 mb-6">Consumption Details</h3>

                      {/* Overall Progress Bar */}
                      <div className="mb-6">
                        <div className="flex justify-between text-sm text-gray-600 mb-2">
                          <span>Overall Route Consumption Score</span>
                          <span className="font-semibold">{routeConsumptionSummary.overallConsumption}%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-5">
                          <div
                            className={`h-5 rounded-full transition-all duration-500 ${
                              routeConsumptionSummary.overallConsumption >= 75 ? 'bg-green-500' :
                              routeConsumptionSummary.overallConsumption >= 50 ? 'bg-lime-500' :
                              routeConsumptionSummary.overallConsumption >= 25 ? 'bg-orange-500' :
                              'bg-red-500'
                            }`}
                            style={{ width: `${routeConsumptionSummary.overallConsumption}%` }}
                          />
                        </div>
                        <p className="text-xs text-gray-500 mt-2">
                          Based on {routeConsumptionSummary.traysAnalyzed} analyzed trays across {routeConsumptionSummary.totalFlights} flights
                        </p>
                      </div>

                      {/* Per-Item Consumption Summary */}
                      <h4 className="text-lg font-semibold text-gray-800 mb-4">Consumption by Menu Item</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {Object.values(routeConsumptionSummary.items).map((item, idx) => (
                          <div key={idx} className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                            <h5 className="font-bold text-gray-800 mb-3">{item.name}</h5>
                            {item.totalTrays > 0 ? (
                              <>
                                <div className="mb-2">
                                  <div className="flex justify-between text-sm text-gray-600 mb-1">
                                    <span>Average Consumed</span>
                                    <span className={`font-semibold ${
                                      item.averageConsumed >= 75 ? 'text-green-600' :
                                      item.averageConsumed >= 50 ? 'text-lime-600' :
                                      item.averageConsumed >= 25 ? 'text-orange-500' :
                                      'text-red-500'
                                    }`}>{item.averageConsumed}%</span>
                                  </div>
                                  <div className="w-full bg-gray-200 rounded-full h-3">
                                    <div
                                      className={`h-3 rounded-full transition-all duration-500 ${
                                        item.averageConsumed >= 75 ? 'bg-green-500' :
                                        item.averageConsumed >= 50 ? 'bg-lime-500' :
                                        item.averageConsumed >= 25 ? 'bg-orange-500' :
                                        item.averageConsumed > 0 ? 'bg-red-400' : 'bg-gray-300'
                                      }`}
                                      style={{ width: `${item.averageConsumed}%` }}
                                    />
                                  </div>
                                </div>
                                <p className="text-xs text-gray-500 mb-2">
                                  Detected in {item.totalTrays} trays
                                </p>
                                <div className="flex flex-wrap gap-1">
                                  {item.consumptionLevels.untouched > 0 && (
                                    <span className="px-2 py-1 bg-emerald-100 text-emerald-800 rounded text-xs">
                                      Untouched: {item.consumptionLevels.untouched}
                                    </span>
                                  )}
                                  {item.consumptionLevels.slightly_eaten > 0 && (
                                    <span className="px-2 py-1 bg-lime-100 text-lime-800 rounded text-xs">
                                      Slightly: {item.consumptionLevels.slightly_eaten}
                                    </span>
                                  )}
                                  {item.consumptionLevels.half_eaten > 0 && (
                                    <span className="px-2 py-1 bg-amber-100 text-amber-800 rounded text-xs">
                                      Half: {item.consumptionLevels.half_eaten}
                                    </span>
                                  )}
                                  {item.consumptionLevels.mostly_eaten > 0 && (
                                    <span className="px-2 py-1 bg-orange-100 text-orange-800 rounded text-xs">
                                      Mostly: {item.consumptionLevels.mostly_eaten}
                                    </span>
                                  )}
                                  {item.consumptionLevels.finished > 0 && (
                                    <span className="px-2 py-1 bg-red-100 text-red-800 rounded text-xs">
                                      Finished: {item.consumptionLevels.finished}
                                    </span>
                                  )}
                                </div>
                              </>
                            ) : (
                              <p className="text-sm text-gray-400 italic">Not detected in any tray</p>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Flight-by-Flight Comparison */}
                  {routeConsumptionSummary?.flightSummaries && (
                    <div className="bg-white rounded-xl p-4 mb-6 shadow-md">
                      <h3 className="text-lg font-bold text-gray-800 mb-4">Flight Comparison</h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        {routeConsumptionSummary.flightSummaries.map((flightSum, idx) => (
                          <div key={idx} className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-4 border border-gray-200">
                            <div className="flex items-center gap-2 mb-2">
                              <Plane className="w-5 h-5 text-blue-600" />
                              <span className="font-bold text-gray-800">{flightSum.flightNumber}</span>
                            </div>
                            <p className="text-xs text-gray-500 mb-3">{flightSum.departureDate} at {flightSum.departureTime}</p>
                            <div className="space-y-2">
                              <div className="flex justify-between text-sm">
                                <span className="text-gray-500">Trays Analyzed</span>
                                <span className="font-semibold">{flightSum.traysAnalyzed}/{flightSum.mealsLoaded}</span>
                              </div>
                              <div className="flex justify-between text-sm">
                                <span className="text-gray-500">Consumption</span>
                                <span className={`font-bold ${
                                  flightSum.overallConsumption >= 75 ? 'text-green-600' :
                                  flightSum.overallConsumption >= 50 ? 'text-lime-600' :
                                  flightSum.overallConsumption >= 25 ? 'text-orange-500' :
                                  'text-red-500'
                                }`}>{flightSum.overallConsumption}%</span>
                              </div>
                              <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
                                <div
                                  className={`h-2 rounded-full ${
                                    flightSum.overallConsumption >= 75 ? 'bg-green-500' :
                                    flightSum.overallConsumption >= 50 ? 'bg-lime-500' :
                                    flightSum.overallConsumption >= 25 ? 'bg-orange-500' :
                                    'bg-red-500'
                                  }`}
                                  style={{ width: `${flightSum.overallConsumption}%` }}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Per-Flight Analysis */}
                  <div className="space-y-4">
                    <h3 className="text-lg font-bold text-gray-800">Per-Flight Analysis</h3>
                    {routeFlights.map((flight) => {
                      const flightCompleted = flight.images.filter(img => img.status === 'complete').length;
                      const flightInfo = flight.metadata.flightInformation;
                      const flightRoute = flight.metadata.routeDetails;

                      return (
                        <div key={flight.id} className="bg-white rounded-xl shadow-md overflow-hidden">
                          {/* Flight Header - Clickable */}
                          <div
                            className="p-4 cursor-pointer hover:bg-gray-50 transition-colors"
                            onClick={() => toggleFlightExpanded(flight.id)}
                          >
                            <div className="flex items-center justify-between">
                              <div className="flex items-center gap-4">
                                <div className="flex items-center gap-2">
                                  <Plane className="w-6 h-6 text-blue-600" />
                                  <span className="font-bold text-lg text-gray-800">{flightInfo.flightNumber}</span>
                                </div>
                                <span className="text-gray-500">
                                  {flightRoute.origin.airportCode} → {flightRoute.destination.airportCode}
                                </span>
                                <span className="text-sm text-gray-400">
                                  {flightRoute.departureDate} at {flightRoute.departureTime}
                                </span>
                              </div>
                              <div className="flex items-center gap-4">
                                <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
                                  {flightCompleted}/{flight.images.length} analyzed
                                </span>
                                {flight.isExpanded ? (
                                  <ChevronUp className="w-5 h-5 text-gray-500" />
                                ) : (
                                  <ChevronDown className="w-5 h-5 text-gray-500" />
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Expanded Content */}
                          {flight.isExpanded && (
                            <div className="border-t border-gray-200 p-4 bg-gray-50">
                              {/* Images Grid - Pre-computed results */}
                              {flight.images.length > 0 ? (
                                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
                                  {flight.images.map((image) => (
                                    <div key={image.id} className="relative bg-white rounded-lg overflow-hidden shadow border border-gray-200">
                                      <img
                                        src={image.preview}
                                        alt={image.name}
                                        className="w-full h-32 object-cover"
                                      />
                                      <div className="absolute top-2 right-2">
                                        <div className="bg-white rounded-full p-1 shadow">
                                          {getStatusIcon(image.status)}
                                        </div>
                                      </div>
                                      <div className="p-2">
                                        <p className="text-xs text-gray-600 truncate">{image.name}</p>
                                        {image.status === 'complete' && image.predictions.length > 0 && (
                                          <div className="mt-1 space-y-1">
                                            {image.predictions.slice(0, 2).map((pred, pIdx) => (
                                              <div key={pIdx} className="flex items-center gap-1">
                                                <span className="text-xs text-gray-500 truncate flex-1">{pred.name}</span>
                                                <span className={`text-xs px-1.5 py-0.5 rounded ${
                                                  getConsumptionLevelStyle(pred.consumptionLevel).color
                                                }`}>
                                                  {consumptionToPercent(pred.consumptionLevel)}%
                                                </span>
                                              </div>
                                            ))}
                                            {image.predictions.length > 2 && (
                                              <p className="text-xs text-gray-400">+{image.predictions.length - 2} more</p>
                                            )}
                                          </div>
                                        )}
                                        {image.status === 'error' && (
                                          <p className="text-xs text-red-500 mt-1">Analysis failed</p>
                                        )}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <div className="text-center py-8 text-gray-500">
                                  <ImageIcon className="w-12 h-12 mx-auto mb-2 text-gray-300" />
                                  <p>No images found in flight folder</p>
                                  <p className="text-xs text-gray-400 mt-1">Add tray1.png - tray5.png to the flight folder</p>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  {/* No Data Message */}
                  {!routeConsumptionSummary && (
                    <div className="bg-white rounded-xl p-8 text-center mt-6">
                      <MapPin className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                      <p className="text-gray-500">No analysis data available for this day.</p>
                    </div>
                  )}
                </div>
              )}

          {/* Tray Details Sub-tab */}
          {routeSubTab === 'trayDetails' && (
            <div className="bg-gradient-to-r from-green-50 to-teal-50 rounded-2xl p-6 border-2 border-green-200">
              <div className="flex items-center gap-3 mb-6">
                <LayoutGrid className="w-8 h-8 text-green-600" />
                <div>
                  <h2 className="text-2xl font-bold text-gray-800">Tray Details</h2>
                  <p className="text-gray-500">Detailed consumption analysis for all {allTrayImages.length} trays</p>
                </div>
              </div>

              {/* Stats Summary */}
              <div className="bg-white rounded-xl p-4 mb-6 shadow-md">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="text-center p-3 bg-green-50 rounded-lg">
                    <p className="text-2xl font-bold text-green-700">{allTrayImages.length}</p>
                    <p className="text-sm text-gray-500">Total Trays</p>
                  </div>
                  <div className="text-center p-3 bg-blue-50 rounded-lg">
                    <p className="text-2xl font-bold text-blue-700">{availableDays.length}</p>
                    <p className="text-sm text-gray-500">Days Covered</p>
                  </div>
                  <div className="text-center p-3 bg-purple-50 rounded-lg">
                    <p className="text-2xl font-bold text-purple-700">{availableDays.length * 4}</p>
                    <p className="text-sm text-gray-500">Total Flights</p>
                  </div>
                  <div className="text-center p-3 bg-amber-50 rounded-lg">
                    <p className="text-2xl font-bold text-amber-700">
                      {allTrayImages.reduce((sum, tray) => sum + (tray.predictions?.length || 0), 0)}
                    </p>
                    <p className="text-sm text-gray-500">Items Detected</p>
                  </div>
                </div>
              </div>

              {/* Tray Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {allTrayImages.map((tray, idx) => {
                  // Calculate tray's overall consumption
                  const trayTotalConsumption = tray.predictions?.reduce((sum, pred) =>
                    sum + consumptionToPercent(pred.consumptionLevel), 0) || 0;
                  const trayAvgConsumption = tray.predictions?.length > 0
                    ? Math.round(trayTotalConsumption / tray.predictions.length)
                    : 0;

                  return (
                    <div key={tray.id || idx} className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
                      {/* Tray Image */}
                      <div className="relative">
                        <img
                          src={tray.preview}
                          alt={tray.name}
                          className="w-full h-48 object-cover"
                        />
                        <div className="absolute top-2 left-2">
                          <span className="px-2 py-1 bg-white/90 rounded-lg text-xs font-semibold text-gray-700">
                            {tray.day}
                          </span>
                        </div>
                        <div className="absolute top-2 right-2">
                          <span className="px-2 py-1 bg-blue-500 text-white rounded-lg text-xs font-semibold">
                            {tray.flightNumber}
                          </span>
                        </div>
                        <div className="absolute bottom-2 right-2">
                          <span className={`px-2 py-1 rounded-lg text-xs font-bold ${
                            trayAvgConsumption >= 75 ? 'bg-green-500 text-white' :
                            trayAvgConsumption >= 50 ? 'bg-lime-500 text-white' :
                            trayAvgConsumption >= 25 ? 'bg-orange-500 text-white' :
                            'bg-red-500 text-white'
                          }`}>
                            {trayAvgConsumption}% consumed
                          </span>
                        </div>
                      </div>

                      {/* Tray Info */}
                      <div className="p-4">
                        <div className="flex items-center justify-between mb-3">
                          <h3 className="font-bold text-gray-800 truncate">{tray.name}</h3>
                          <div className="bg-green-100 rounded-full p-1">
                            <CheckCircle className="w-4 h-4 text-green-600" />
                          </div>
                        </div>

                        <p className="text-xs text-gray-500 mb-3">
                          {tray.departureDate} at {tray.departureTime}
                        </p>

                        {/* Detailed Items Consumption */}
                        <div className="space-y-2">
                          <p className="text-sm font-semibold text-gray-700 mb-2">Items Detected:</p>
                          {tray.predictions && tray.predictions.length > 0 ? (
                            tray.predictions.map((pred, pIdx) => {
                              const style = getConsumptionLevelStyle(pred.consumptionLevel);
                              return (
                                <div key={pIdx} className="bg-gray-50 rounded-lg p-2 border border-gray-100">
                                  <div className="flex items-center justify-between mb-1">
                                    <span className="text-sm font-medium text-gray-800">{pred.name}</span>
                                    <span className={`text-xs px-2 py-0.5 rounded-full border ${style.color}`}>
                                      {style.label}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-2">
                                    <div className="flex-1 bg-gray-200 rounded-full h-2">
                                      <div
                                        className={`h-2 rounded-full ${
                                          consumptionToPercent(pred.consumptionLevel) >= 75 ? 'bg-green-500' :
                                          consumptionToPercent(pred.consumptionLevel) >= 50 ? 'bg-lime-500' :
                                          consumptionToPercent(pred.consumptionLevel) >= 25 ? 'bg-orange-500' :
                                          consumptionToPercent(pred.consumptionLevel) > 0 ? 'bg-red-400' : 'bg-gray-300'
                                        }`}
                                        style={{ width: `${consumptionToPercent(pred.consumptionLevel)}%` }}
                                      />
                                    </div>
                                    <span className="text-xs font-semibold text-gray-600 w-10 text-right">
                                      {consumptionToPercent(pred.consumptionLevel)}%
                                    </span>
                                  </div>
                                  {pred.description && (
                                    <p className="text-xs text-gray-500 mt-1 italic">{pred.description}</p>
                                  )}
                                </div>
                              );
                            })
                          ) : (
                            <p className="text-sm text-gray-400 italic">No items detected</p>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Empty State */}
              {allTrayImages.length === 0 && (
                <div className="bg-white rounded-xl p-8 text-center">
                  <LayoutGrid className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                  <p className="text-gray-500">No tray data available.</p>
                </div>
              )}
            </div>
          )}
          </div>
          </div>
          )}
        </div>

        {/* Right Side - Agent Chat (Only visible when not on agent tab) */}
        {activeTab !== 'agent' && (
        <div className="w-96 flex-shrink-0">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden sticky top-4">
            <div className="p-4" style={{ backgroundColor: '#b08747' }}>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                  <Bot className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h2 className="text-lg font-bold text-white">AI Assistant</h2>
                  <p className="text-amber-100 text-xs">Ask questions about your data</p>
                </div>
              </div>
            </div>

            {/* Chat Messages */}
            <div className="h-[400px] overflow-y-auto p-4 space-y-3 bg-gray-50">
              {chatMessages.map((msg, idx) => (
                <div
                  key={idx}
                  className={`flex gap-2 ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}
                >
                  {msg.role === 'assistant' && (
                    <div className="flex-shrink-0 w-7 h-7 rounded-full bg-amber-100 flex items-center justify-center">
                      <Bot className="w-4 h-4 text-amber-700" />
                    </div>
                  )}
                  <div
                    className={`max-w-[85%] rounded-xl px-3 py-2 ${
                      msg.role === 'user'
                        ? 'text-gray-800 border'
                        : 'bg-white text-gray-800 shadow-sm border border-gray-100'
                    }`}
                    style={msg.role === 'user' ? { backgroundColor: '#fdf9ef', borderColor: '#b08747' } : {}}
                  >
                    {msg.role === 'assistant' ? (
                      <div className="text-sm prose prose-sm max-w-none prose-headings:text-gray-800 prose-headings:font-bold prose-headings:mt-2 prose-headings:mb-1 prose-p:my-1 prose-ul:my-1 prose-li:my-0 prose-strong:text-gray-900">
                        <ReactMarkdown>{msg.content}</ReactMarkdown>
                      </div>
                    ) : (
                      <p className="text-sm">{msg.content}</p>
                    )}
                  </div>
                  {msg.role === 'user' && (
                    <div className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center" style={{ backgroundColor: '#fdf9ef' }}>
                      <User className="w-4 h-4 text-gray-700" />
                    </div>
                  )}
                </div>
              ))}
              {isAgentLoading && (
                <div className="flex gap-2 justify-start">
                  <div className="flex-shrink-0 w-7 h-7 rounded-full bg-amber-100 flex items-center justify-center">
                    <Bot className="w-4 h-4 text-amber-700" />
                  </div>
                  <div className="bg-white rounded-xl px-3 py-2 shadow-sm border border-gray-100">
                    <div className="flex gap-1">
                      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
                    </div>
                  </div>
                </div>
              )}
              <div ref={chatEndRef} />
            </div>

            {/* Quick Questions */}
            <div className="p-3 border-t border-gray-200 bg-white">
              <div className="flex flex-wrap gap-1 mb-3">
                {[
                  "Most wasted items?",
                  "Best consumption day?",
                  "Reduce waste tips?"
                ].map((question, idx) => (
                  <button
                    key={idx}
                    onClick={() => setChatInput(question)}
                    className="px-2 py-1 bg-gray-100 text-gray-600 rounded text-xs hover:bg-amber-50 hover:text-amber-700 transition-colors"
                  >
                    {question}
                  </button>
                ))}
              </div>

              {/* Chat Input */}
              <div className="flex gap-2">
                <input
                  type="text"
                  value={chatInput}
                  onChange={(e) => setChatInput(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && sendMessageToAgent()}
                  placeholder="Ask a question..."
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                  disabled={isAgentLoading}
                />
                <button
                  onClick={sendMessageToAgent}
                  disabled={isAgentLoading || !chatInput.trim()}
                  className={`p-2 rounded-lg transition-colors ${
                    isAgentLoading || !chatInput.trim()
                      ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                      : 'text-white hover:opacity-90'
                  }`}
                  style={!isAgentLoading && chatInput.trim() ? { backgroundColor: '#b08747' } : {}}
                >
                  <Send className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        </div>
        )}
      </div>
      </div>
    </div>
  );
}

export default App;